// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as DeliveryRouteImport } from './routes/delivery'
import { Route as StoryRouteImport } from './routes/story'
import { Route as WarrantyRouteImport } from './routes/warranty'
import { Route as ConceptsIndexRouteImport } from './routes/concepts.index'
import { Route as ConceptsSlugRouteImport } from './routes/concepts.$slug'
import { Route as ProductHandleRouteImport } from './routes/product.$handle'
import { Route as WarrantyIndexRouteImport } from './routes/warranty.index'
import { Route as WarrantyClaimRouteImport } from './routes/warranty.claim'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const DeliveryRoute = DeliveryRouteImport.update({
            id: '/delivery',path: '/delivery',getParentRoute: () => rootRouteImport
          })
const StoryRoute = StoryRouteImport.update({
            id: '/story',path: '/story',getParentRoute: () => rootRouteImport
          })
const WarrantyRoute = WarrantyRouteImport.update({
            id: '/warranty',path: '/warranty',getParentRoute: () => rootRouteImport
          })
const ConceptsIndexRoute = ConceptsIndexRouteImport.update({
            id: '/concepts/',path: '/concepts/',getParentRoute: () => rootRouteImport
          })
const ConceptsSlugRoute = ConceptsSlugRouteImport.update({
            id: '/concepts/$slug',path: '/concepts/$slug',getParentRoute: () => rootRouteImport
          })
const ProductHandleRoute = ProductHandleRouteImport.update({
            id: '/product/$handle',path: '/product/$handle',getParentRoute: () => rootRouteImport
          })
const WarrantyIndexRoute = WarrantyIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WarrantyRoute
          })
const WarrantyClaimRoute = WarrantyClaimRouteImport.update({
            id: '/claim',path: '/claim',getParentRoute: () => WarrantyRoute
          })





const WarrantyRouteChildren = {
  WarrantyClaimRoute: WarrantyClaimRoute,WarrantyIndexRoute: WarrantyIndexRoute
}

const WarrantyRouteWithChildren = WarrantyRoute._addFileChildren(WarrantyRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,DeliveryRoute: DeliveryRoute,StoryRoute: StoryRoute,WarrantyRoute: WarrantyRouteWithChildren,ConceptsSlugRoute: ConceptsSlugRoute,ProductHandleRoute: ProductHandleRoute,ConceptsIndexRoute: ConceptsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)